import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import tranEn from "./en/resource.json";
import tranKo from "./ko/resource.json";
import tranAr from "./ar/resource.json";

import tranOCIEn from "./en/resource_oci.json";
import tranOCIKo from "./ko/resource_oci.json";
import tranOCIAr from "./ar/resource_OCI.json";

const resources = {
  en: {
    translation: tranEn, // 기본
    oci: tranOCIEn, // OCI 전용(있으면 여기 우선)
  },
  ko: {
    translation: tranKo,
    oci: tranOCIKo,
  },
  ar: {
    translation: tranAr,
    oci: tranOCIAr,
  },
};

const fallbackLng = ["en"];

interface Navigator1 {
  userLanguage?: string;
  browserLanguage?: string;
  languages: readonly string[];
  language: string;
}

const nowNavigator: Navigator1 = window.navigator;
const isOCI = window?.eco?.serviceType === "OCI";
const ns = isOCI ? ["oci", "translation"] : ["translation"];
const defaultNS = isOCI ? "oci" : "translation";
const fallbackNS = isOCI ? ["translation"] : []; // oci 키 없으면 translation으로 자동 폴백

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    ns,
    defaultNS,
    fallbackNS,
    interpolation: {
      escapeValue: false, // 이걸 해줘야 '/'가 &#x2F;로 안 변해요
    },
    lng: (() => {
      const urlLang = new URLSearchParams(window.location.search).get("lang");
      if (urlLang && ["en", "ko", "ar"].includes(urlLang)) return urlLang;
      if (window.navigator.language === "ar") return "ar";
      if (["ko", "ko-KR", "ko-kr"].includes(window.navigator.language)) return "ko";
      if (["en", "en-US", "en-us"].includes(window.navigator.language)) return "en";
      if (nowNavigator.browserLanguage && ["ko", "ko-KR", "ko-kr"].includes(nowNavigator.browserLanguage)) return "ko";
      return "en";
    })(),
    supportedLngs: ["en", "ko", "ar"],
    fallbackLng,
    debug: true,
  });

export default i18next;
